export default {
      id: "sh-hl-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#sh-hl",
      toString: function () {
        return this.url;
      }
    }